<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaStatusOdontograma"
        title-table="Status Odontograma"
        module="statusOdontogramaSettingsModule"
        sort-name="nome"
        :add-permission="'ROLE_ODONTOGRAMA_STATUS_INSERIR'"
        :view-permission="'ROLE_ODONTOGRAMA_STATUS_CONSULTAR'"
        :edit-permission="'ROLE_ODONTOGRAMA_STATUS_ATUALIZAR'"
        :delete-permission="'ROLE_ODONTOGRAMA_STATUS_DELETAR'"
        @add="addNew"
        @edit="edit"
      />
      <FormStatusOdontograma
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormStatusOdontograma from './forms/FormStatusOdontograma.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormStatusOdontograma,
  },

  computed: {
    ...mapState('statusOdontogramaSettingsModule', {
      listaStatusOdontograma: state => state.listaStatusOdontograma,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Nome',
          field: 'nome',
        },
        {
          label: 'Descrição',
          field: 'descricao',
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.$store.dispatch('statusOdontogramaSettingsModule/reset')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('statusOdontogramaSettingsModule/prepareToEdit', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
